/* ============================================================
   Cardio Online — custom shipping calculator
   Replaces the Octolize "Shipping Rates Calculator" app.

   Two modes (same UI, same live carrier rates):
     • PDP mode (default): the product isn't in the cart yet, so it
       temporarily adds 1 unit of the selected variant, quotes the
       cart, then restores the line to its original qty.
     • Cart mode ([data-cosc-cart]): used on the cart page + drawer.
       Quotes live rates for the WHOLE current cart and never
       modifies it.

   Flow (Shopify's native AJAX rate endpoints):
     POST /cart/prepare_shipping_rates  -> triggers carrier apps
     GET  /cart/async_shipping_rates    -> poll until rates ready
   PDP mode wraps that with /cart/add.json + /cart/change.js restore.

   Initialised via event delegation so it also works for the cart
   drawer, whose markup is injected by AJAX after page load.
   ============================================================ */
(function () {
  if (window.__coscLoaded) return;
  window.__coscLoaded = true;

  function money(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return val;
    var s = '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s.replace(/\.00$/, '');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function req(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.text().then(function (t) {
        var data = null;
        try { data = t ? JSON.parse(t) : null; } catch (e) {}
        return { status: r.status, data: data, text: t };
      });
    });
  }

  function sleep(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  /* Always read the live variant id from the buy form so the quote
     follows variant selection; fall back to the block's own attribute. */
  function currentVariantId(root) {
    var hid = document.querySelector('[data-pdpc-id]') ||
              document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (hid && hid.value) return hid.value;
    return root.getAttribute('data-variant-id');
  }

  function pollRates(query, attempts) {
    return req('/cart/async_shipping_rates.json?' + query, { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (res.status === 200 && res.data && res.data.shipping_rates) {
          return res.data.shipping_rates;
        }
        if (attempts <= 0) throw new Error('timeout');
        return sleep(700).then(function () { return pollRates(query, attempts - 1); });
      });
  }

  function restore(variantId, origQty) {
    return req('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: origQty })
    }).catch(function () { /* best effort */ });
  }

  function renderRates(resultEl, rates, zip) {
    if (!rates || !rates.length) {
      resultEl.className = 'cosc__result is-empty';
      resultEl.innerHTML = 'No shipping options were returned for ' + escapeHtml(zip) +
        '. Please double-check the postcode, or <a href="tel:0370479313">call us on 03 7047 9313</a>.';
      return;
    }
    rates = rates.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    var html = '<p class="cosc__result-head">Shipping to ' + escapeHtml(zip) + ':</p><ul class="cosc__rates">';
    rates.forEach(function (r) {
      var p = parseFloat(r.price);
      var label = (p === 0) ? 'FREE' : money(r.price);
      var name = r.presentment_name || r.name || 'Shipping';
      html += '<li class="cosc__rate">' +
                '<span class="cosc__rate-name">' + escapeHtml(name) + '</span>' +
                '<span class="cosc__rate-price' + (p === 0 ? ' is-free' : '') + '">' + label + '</span>' +
              '</li>';
    });
    html += '</ul>';
    resultEl.className = 'cosc__result is-success';
    resultEl.innerHTML = html;
  }

  function calculate(root) {
    var resultEl = root.querySelector('[data-cosc-result]');
    var btn = root.querySelector('[data-cosc-calc]');
    var province = (root.querySelector('[data-cosc-state]') || {}).value || '';
    var zipEl = root.querySelector('[data-cosc-zip]');
    var cityEl = root.querySelector('[data-cosc-city]');
    var zip = zipEl ? zipEl.value.trim() : '';
    var city = cityEl ? cityEl.value.trim() : '';
    province = province.trim();

    var cartMode = root.hasAttribute('data-cosc-cart');

    if (!province || !zip) {
      resultEl.className = 'cosc__result is-error';
      resultEl.innerHTML = 'Please choose your state and enter a postcode.';
      return;
    }
    if (!/^\d{3,4}$/.test(zip)) {
      resultEl.className = 'cosc__result is-error';
      resultEl.innerHTML = 'Please enter a valid Australian postcode.';
      return;
    }
    if (cityEl && !city) {
      resultEl.className = 'cosc__result is-error';
      resultEl.innerHTML = 'Please enter your suburb.';
      return;
    }

    var addr = new URLSearchParams();
    addr.set('shipping_address[zip]', zip);
    addr.set('shipping_address[country]', 'Australia');
    addr.set('shipping_address[province]', province);
    if (city) addr.set('shipping_address[city]', city);
    var query = addr.toString();

    var origLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Calculating…';
    resultEl.className = 'cosc__result is-loading';
    resultEl.innerHTML = '<span class="cosc__spinner" aria-hidden="true"></span> Fetching live rates to ' + escapeHtml(zip) + '…';

    function done() { btn.disabled = false; btn.textContent = origLabel; }

    /* ---------- Cart mode: quote the existing cart, untouched ---------- */
    if (cartMode) {
      req('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          var count = (res.data && res.data.item_count) || 0;
          if (!count) {
            var e = new Error('empty');
            e.friendly = 'Your cart is empty, so there’s nothing to quote yet.';
            throw e;
          }
          return req('/cart/prepare_shipping_rates.json?' + query, { method: 'POST', headers: { 'Accept': 'application/json' } });
        })
        .then(function () { return pollRates(query, 14); })
        .then(function (rates) { renderRates(resultEl, rates, zip); })
        .catch(function (err) {
          resultEl.className = 'cosc__result is-error';
          resultEl.innerHTML = (err && err.friendly) ||
            ('Something went wrong fetching the rate. Please try again, or call us on <a href="tel:0370479313">03 7047 9313</a>.');
        })
        .then(done);
      return;
    }

    /* ---------- PDP mode: add 1 unit, quote, restore ------------------- */
    var variantId = currentVariantId(root);
    if (!variantId) {
      resultEl.className = 'cosc__result is-error';
      resultEl.innerHTML = 'We couldn’t identify this product — please refresh and try again.';
      done();
      return;
    }

    var origQty = 0;

    req('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        var items = (res.data && res.data.items) || [];
        items.forEach(function (it) { if (String(it.id) === String(variantId)) origQty += it.quantity; });
        return req('/cart/add.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
      })
      .then(function (res) {
        if (res.status !== 200) {
          var msg = (res.data && res.data.description) || '';
          var e = new Error('add_failed');
          e.friendly = /sold out|stock|unavailable/i.test(msg)
              ? 'This item is currently unavailable, so we can’t calculate shipping for it.'
              : null;
          throw e;
        }
        return req('/cart/prepare_shipping_rates.json?' + query, { method: 'POST', headers: { 'Accept': 'application/json' } });
      })
      .then(function () { return pollRates(query, 14); })
      .then(function (rates) { return restore(variantId, origQty).then(function () { return rates; }); })
      .then(function (rates) { renderRates(resultEl, rates, zip); })
      .catch(function (err) {
        restore(variantId, origQty);
        resultEl.className = 'cosc__result is-error';
        resultEl.innerHTML = (err && err.friendly) ||
          ('Something went wrong fetching the rate. Please try again, or call us on <a href="tel:0370479313">03 7047 9313</a>.');
      })
      .then(done);
  }

  function toggleRoot(root) {
    var toggle = root.querySelector('[data-cosc-toggle]');
    var panel = root.querySelector('[data-cosc-panel]');
    var open = root.classList.toggle('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  /* Event delegation — works for PDP blocks present at load AND for the
     cart drawer, whose markup is injected by AJAX after load. */
  document.addEventListener('click', function (e) {
    var tg = e.target.closest && e.target.closest('[data-cosc-toggle]');
    if (tg) { var r1 = tg.closest('[data-cosc]'); if (r1) toggleRoot(r1); return; }
    var cb = e.target.closest && e.target.closest('[data-cosc-calc]');
    if (cb) { var r2 = cb.closest('[data-cosc]'); if (r2) calculate(r2); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var z = e.target.closest && e.target.closest('[data-cosc-zip]');
    if (z) { e.preventDefault(); var r = z.closest('[data-cosc]'); if (r) calculate(r); }
  });
})();
